import clsx from 'clsx'
import React from 'react'

export type Option = {
  label: string
  value: string
}

export type SelectProps = {
  label: string
  options?: Option[]
  error?: string
  onChange: React.ChangeEventHandler<HTMLSelectElement>
} & Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'>

const Select = ({
  label,
  options = [],
  onChange,
  error,
  ...rest
}: SelectProps) => {
  return (
    <div className="flex flex-col gap-y-2">
      <label htmlFor="select" className="text-sm text-zinc-400">
        {label}
        {rest.required && '*'}
      </label>
      <select
        {...rest}
        id="select"
        onChange={onChange}
        className={clsx(
          'input arrow option h-[59px] w-full appearance-none rounded-lg border border-zinc-200 px-5 text-base text-slate-500 placeholder:text-base placeholder:text-[#CFD4DD]',
          error && 'error',
          rest.disabled &&
            'cursor-not-allowed border border-gray-200 bg-gray-100'
        )}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default Select
